import { useState, useCallback, useRef } from "react";

export default function useModalManager() {
  const [stack, setStack] = useState([]);
  const nextId = useRef(0);

  const generateId = useCallback(() => {
    nextId.current += 1;
    return `modal-${nextId.current}`;
  }, []);

  const closeById = useCallback((id) => {
    setStack((prev) => prev.filter((m) => m.id !== id));
  }, []);

  const open = useCallback(
    (component, props, options) =>
      new Promise((resolve) => {
        const id = options?.id || generateId();

        function closeCurrentModal(value, r) {
          r(value);
          closeById(id);
        }

        const modalInstance = {
          component,
          data: props || {},
          id,
          isOpen: true,
          close: (value) => closeCurrentModal(value, resolve),
        };

        setStack((prev) => [...prev, modalInstance]);
      }),
    [generateId, closeById]
  );

  const close = useCallback((n = 1) => {
    setStack((prev) => {
      const toClose = prev.slice(-n);
      const newStack = prev.slice(0, prev.length - toClose.length);
      toClose.forEach((modal) => modal.close(undefined));
      return newStack;
    });
  }, []);

  const closeAll = useCallback(() => {
    setStack((prev) => {
      prev.forEach((modal) => modal.close(undefined));
      return [];
    });
  }, []);

  return {
    open,
    close,
    closeById,
    closeAll,
    stack,
  };
}
